import { MdOutlineStickyNote2 } from 'react-icons/md';
import { Case, CaseLog, CaseLogEventType } from '@/api/apis/case';
import { caseLogEventNames } from '@/constants/case/case.constants';
import { CaseLogCardContentRecord } from './CaseLogCardContentRecord';
import { renderTextIcon } from './utils';

const logTypesWithMessage = [
  CaseLogEventType.CaseNoteAdded,
  CaseLogEventType.CaseNoteRemoved,
  CaseLogEventType.CaseNoteUpdated,
  CaseLogEventType.CaseQuoteCommentSet,
  /* CaseLogEventType.CaseQuoteApproved, */
];

type CaseLogRecordContentProps = {
  log: CaseLog;
  caseData: Case;
};

export const CaseLogCardContent = ({ log, caseData }: CaseLogRecordContentProps) => {
  const hideTitle =
    log.eventType === CaseLogEventType.IdentityAccessTicketGranted ||
    log.eventType === CaseLogEventType.IdentityAccessTicketRevoked ||
    log.eventType === CaseLogEventType.CaseQuoteDryRunDiscountExcluded;

  const logEventName = caseLogEventNames[log.eventType];

  const multilinedEvents = [
    CaseLogEventType.CaseResourceAssigned,
    CaseLogEventType.CaseResourceReassigned,
    CaseLogEventType.CaseResourceUnassigned,
    CaseLogEventType.CaseAssignedEmployeePrimaryChanged,
    CaseLogEventType.CaseResourceLabelsChanged,
    CaseLogEventType.DonorDataUpdated,
    CaseLogEventType.CaseSplitIntoOrgans,
  ];

  if (!logEventName) {
    return (
      <span className="text-m-r text-base-5">
        Unknown log type: <b>{log.eventType}</b>
      </span>
    );
  }

  if (log.logRecords.length === 1 && !multilinedEvents.includes(log.eventType)) {
    const record = log.logRecords[0];
    const isQuoteTotals = !!log.quoteTotals;

    return (
      <>
        <div className={`flex gap-2 overflow-hidden ${isQuoteTotals ? 'flex-col' : 'items-center'}`}>
          {!hideTitle && <span className="text-m-r text-base-5 shrink-0">{logEventName}</span>}
          <CaseLogCardContentRecord record={record} log={log} caseData={caseData} />
        </div>

        {logTypesWithMessage.includes(log.eventType) && record.value && (
          <div className="ml-3">{renderTextIcon(`"${record.value}"`, <MdOutlineStickyNote2 size={20} />)}</div>
        )}
      </>
    );
  }

  return (
    <div className="flex flex-1 flex-col gap-2">
      {!hideTitle && <span className="text-m-r text-base-5 shrink-0">{logEventName}</span>}
      {log.logRecords.map((record, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className="flex items-center gap-2">
          {/* <MdCircle className="text-base-10 shrink-0" size={6} /> */}
          {/* <span className="text-s-m text-base-5 shrink-0">{caseLogEventNames[log.eventType]}</span> */}
          <CaseLogCardContentRecord record={record} log={log} caseData={caseData} />
        </div>
      ))}
    </div>
  );
};
